/*
 * discover-lx1-video-player.js — behaviour of snippets/discover-lx1-video-player.liquid, for every player on the page
 * (the hero, and an award video where a store has its own-language cut). Styles: assets/discover-lx1-video-player.css.
 * No dependencies. Loaded (deferred) by the sections that render the player.
 *
 * Autoplay players (data-autoplay="true", the hero) on desktop start muted with an "unmute" badge; a click toggles
 * play/pause. On touch devices, and for data-autoplay="false" players everywhere, a big play button starts the video
 * with sound; on touch a tap shows the toolbar for 3 s. Toolbar: play/pause, seek, time, mute, fullscreen (native
 * iOS fullscreen on iPhone). Resets to the start when the video ends. Moved from an inline <script> on the Instant page.
 */
(function () {
  const isMobile = matchMedia('(hover: none) and (pointer: coarse)').matches;
  const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  function initPlayer(wrap) {
  if (wrap.__dlx1Player) return;
  wrap.__dlx1Player = true;
  // data-autoplay="false" (e.g. the award video): no muted autoplay on desktop — the big play button starts it
  const auto = wrap.getAttribute('data-autoplay') !== 'false';
  const video = wrap.querySelector('.hero-video');
  if (!video) return;
  const q = (sel) => wrap.querySelector(sel);
  const controls = q('.hv-controls');
  const bigPlay = q('.hv-bigplay');
  const unmuteBadge = q('.hv-unmute-badge');
  const btnPlay = q('.icon-play').closest('.hv-btn');
  const btnMute = q('.icon-vol-on').closest('.hv-btn');
  const btns = wrap.querySelectorAll('.hv-controls .hv-btn');
  const btnFs = btns[btns.length - 1];
  const seek = q('.hv-seek');
  const tCur = q('.hv-current');
  const tDur = q('.hv-duration');
  const iconPlay = btnPlay.querySelector('.icon-play');
  const iconPause = btnPlay.querySelector('.icon-pause');
  const iconVolOn = btnMute.querySelector('.icon-vol-on');
  const iconVolMute = btnMute.querySelector('.icon-vol-mute');

  // Reset to start + pause on end
  video.addEventListener('ended', () => {
    video.currentTime = 0;
    video.pause();
    syncPlayIcon();
  });

  if (!isMobile && auto) {
    video.autoplay = true;
    video.muted = true;
    video.play().catch(() => {});
    unmuteBadge.style.display = 'grid';
  } else {
    bigPlay.style.display = 'grid';
    controls.classList.remove('show');
    video.muted = true;
  }

  const fmt = (s) => {
    s = Math.max(0, s | 0);
    const m = (s / 60) | 0,
      r = s % 60 | 0;
    return m + ':' + (r < 10 ? '0' : '') + r;
  };
  const syncPlayIcon = () => {
    const playing = !video.paused;
    iconPlay.style.display = playing ? 'none' : 'block';
    iconPause.style.display = playing ? 'block' : 'none';
  };
  const syncMuteIcons = () => {
    const muted = video.muted || video.volume === 0;
    iconVolOn.style.display = muted ? 'none' : 'block';
    iconVolMute.style.display = muted ? 'block' : 'none';
  };

  bigPlay.addEventListener('click', () => {
    bigPlay.style.display = 'none';
    video.muted = false;
    try {
      video.volume = 1.0;
    } catch (e) {}
    video.play().catch(() => {});
    syncMuteIcons();
    showToolbarTemporarily();
  });

  unmuteBadge.addEventListener('click', () => {
    video.muted = false;
    try {
      video.volume = 1.0;
    } catch (e) {}
    video.play().catch(() => {});
    unmuteBadge.style.display = 'none';
    syncMuteIcons();
  });

  video.addEventListener('volumechange', () => {
    if (!isMobile && auto) unmuteBadge.style.display = video.muted ? 'grid' : 'none';
    syncMuteIcons();
  });

  // Tap toggles toolbar on mobile
  video.addEventListener('click', () => {
    if (isMobile) {
      if (controls.classList.contains('show')) hideToolbar();
      else showToolbarTemporarily();
    } else {
      if (video.paused) video.play().catch(() => {});
      else video.pause();
    }
  });

  btnPlay.addEventListener('click', () => {
    if (video.paused) video.play().catch(() => {});
    else video.pause();
  });
  video.addEventListener('play', syncPlayIcon);
  video.addEventListener('pause', syncPlayIcon);

  btnMute.addEventListener('click', () => {
    video.muted = !video.muted;
    if (!video.muted) {
      try {
        video.volume = 1.0;
      } catch (e) {}
      video.play().catch(() => {});
    }
    syncMuteIcons();
  });

  video.addEventListener('loadedmetadata', () => {
    if (isFinite(video.duration)) tDur.textContent = fmt(video.duration);
  });
  video.addEventListener('timeupdate', () => {
    if (!isFinite(video.duration) || video.duration === 0) return;
    seek.value = (video.currentTime / video.duration) * 100;
    tCur.textContent = fmt(video.currentTime);
  });
  seek.addEventListener('input', () => {
    if (!isFinite(video.duration)) return;
    video.currentTime = (seek.value / 100) * video.duration;
  });

  // Fullscreen (iOS + desktop)
  function isFs() {
    const docFs = document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
    const iosVideoFs = typeof video.webkitDisplayingFullscreen === 'boolean' ? video.webkitDisplayingFullscreen : false;
    return !!(docFs || iosVideoFs);
  }
  function enterFs() {
    if (isMobile && isiOS && typeof video.webkitEnterFullscreen === 'function') {
      video.webkitEnterFullscreen();
      return;
    }
    const req = wrap.requestFullscreen || wrap.webkitRequestFullscreen || wrap.msRequestFullscreen;
    if (req) req.call(wrap);
  }
  function exitFs() {
    if (isMobile && isiOS && typeof video.webkitExitFullscreen === 'function' && video.webkitDisplayingFullscreen) {
      video.webkitExitFullscreen();
      return;
    }
    const exit = document.exitFullscreen || document.webkitExitFullscreen || document.msExitFullscreen;
    if (exit) exit.call(document);
  }
  btnFs.addEventListener('click', (e) => {
    e.preventDefault();
    isFs() ? exitFs() : enterFs();
  });
  document.addEventListener('fullscreenchange', () => wrap.classList.toggle('is-fs', !!isFs()));
  document.addEventListener('webkitfullscreenchange', () => wrap.classList.toggle('is-fs', !!isFs()));

  // Toolbar show/hide
  let hideTimer;
  function showToolbarTemporarily(ms = 3000) {
    controls.classList.add('show');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => hideToolbar(), ms);
  }
  function hideToolbar() {
    controls.classList.remove('show');
    clearTimeout(hideTimer);
  }
  }

  document.querySelectorAll('[data-dlx1-player]').forEach(initPlayer);
})();
